import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.AccountService = function () {

};

HSN.Service.AccountService.prototype = {
    SaveChangesV2: function (data, config) {
        this._send('/myaccount/update/update-password/', data, config);
    },
    SaveChanges: function (oldPassword, newPassword, confirmPassword, config) {
        this._send('/myaccount/update/update-password/', { oldPassword: oldPassword, newPassword: newPassword, confirmPassword: confirmPassword }, config);
    },

    RemoveAddress: function (addressId, config) {
        this._send('/myaccount/address-book/remove-address', { identity: addressId }, config);
    },

    GetAddressList: function (data, config) {
        this._get('/myaccount/address-book/address-list', data, config);
    },        
    GetEditAddressForm: function (addressIdentity, hideTitle, config) {
        this._get('/checkout/add-edit-address', { addressIdentity: addressIdentity, partialOnly: true, hideTitle: hideTitle }, config);
    },
    GetAddAddressForm: function (hideTitle, config) {
        this._get('/checkout/add-edit-address', { partialOnly: true, hideTitle: hideTitle }, config);
    },
    GetEditPaymentForm: function (paymentIdentity, hideTitle, config) {
        this._get('/checkout/add-edit-payment', { paymentIdentity: paymentIdentity, partialOnly: true, hideTitle: hideTitle }, config);
    },
    GetAddPaymentForm: function (data, config) {
        this._get('/checkout/add-edit-payment', data, config);
    },
    GetAccessAndDevicesForm: function (config) {
        this._get('/myaccount/devices-access', { }, config);
    },
    RemoveSession: function (sessionIdentity, config) {
        this._send('/myaccount/devices-access/remove', {sessionIdentity: sessionIdentity}, config);
    },
    /*=====Autoship manager methods=====*/
    AutoshipEnrollmentCancel: function (enrollmentIdentity, config) {
        this._send('/myaccount/autoship-manager/cancel-enrollment/' + enrollmentIdentity, {}, config);
    },
    AutoshipToggleShipment: function (enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/toggle-shipment/' + enrollmentIdentity, data, config);
    },
    AutoshipEditShipment: function (enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/edit-shipment/' + enrollmentIdentity, data, config);
    },
    AutoshipShipmentChangeAddress: function (enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/shipment-change-address/' + enrollmentIdentity, data, config);
    },
    AutoshipChangeAddress: function (enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/change-address/' + enrollmentIdentity, data, config);
    },
    AutoshipChangePayment: function (enrollmentIdentity, data, config) {
        this._send('/myaccount/autoship-manager/change-payment/' + enrollmentIdentity, data, config);
    },
    AutoshipGetEnrollment: function (enrollmentIdentity, data, config) {
        this._get('/myaccount/autoship-manager/enrollment-get/' + enrollmentIdentity, data, config);
    },
    /*=====END Autoship manager methods=====*/
    /*=====Flexpay manager methods=====*/
    SubmitFlexPayment: function (data, config) {
        this._send('/myaccount/flex-manager/pay-now', data, config);
    },
    FlexPayChangePayment: function (data, config) {
        this._send('/myaccount/flex-manager/change-card', data, config);
    },
    FlexPayGetProcessingPage: function(data, config) {
        this._get('/myaccount/flexpay-manager/pay-now/processing/' + data.orderIdentity, $.param(data, true), config);
    },
    FlexPayGetOrder: function (orderIdentity, config) {
        this._get('/myaccount/flexpay-manager/order/' + orderIdentity, {}, config);
    },
    /*=====END Flexpay manager methods=====*/
    SavePhoneBook: function (data, config) {
        this._send('/myaccount/phone-book/save', data, config);
    },
    CancelOrder: function (data, config) {
        this._send('/myaccount/cancel-order', data, config);
    },

    UpdateEmail: function (data, config) {
        this._send('/myaccount/update/update-email/', data, config);
    },

    UpdateAlertStatus: function (EventId, StatusId, config) {
        this._send('/myaccount/alerts/update-alert-status', { eventid: EventId, statusid: StatusId }, config);
    },

    SaveBrandChanges: function (data, config) {
        this._send('/myaccount/compref/brands/save-selections', data, config);
    },

    SaveEmailPreferenceChanges: function (data, config) {
        this._send('/myaccount/compref/email/save-selections', data, config);
    },

    SaveNickname: function (Nickname, GuidelinesAccepted, config) {
        this._send('/myaccount/update/nickname', { nickname: Nickname, guidelinesaccepted: GuidelinesAccepted }, config);
    },

    UpdateProfile: function (BirthdayMonth, BirthdayDay, City, PhotoName, ThumbnailName, HostServer, AboutMe,
            ShowProfileFlag, ShowPostsFlag, ShowFavoritesFlag, ShowScoresFlag, ShowBadgesFlag, ShowReviewsFlag, config) {
        this._send('/myaccount/update/profile', {
            birthdayMonth: BirthdayMonth,
            birthdayDay: BirthdayDay,
            city: City,
            photoName: PhotoName,
            thumbnailName: ThumbnailName,
            hostServer: HostServer,
            aboutme: AboutMe,
            showProfileFlag: ShowProfileFlag,
            showPostsFlag: ShowPostsFlag,
            showFavoritesFlag: ShowFavoritesFlag,
            showScoresFlag: ShowScoresFlag,
            showBadgesFlag: ShowBadgesFlag,
            showReviewsFlag: ShowReviewsFlag
        }, config);
    },

    UploadProfileImage: function (data, config) {
        this._sendMixedData('/myaccount/profile-image-upload/save', data, config);
    },

    Register: function (data, config) {
        this._send('/account/register', data, config);
    },

    SaveAdsCreditCard: function(data, config) {
        this._send('/myaccount/creditcard', data, config);
    },

    GetSingleOrder: function (data, config) {
        this._send('/myaccount/single-order/get-order', data, config);
    },

    ResetCookieInformation: function(data, config) {
        this._send('/signin/reset', data, config);
    },

    Signin: function(data, config) {
        this._send('/signin', data, config);
    },

    SubmitForgotPassword: function (data, config) {
        this._send('/account/forgot-password', data, config);
    },

    GetForgotPasswordVerify: function (data, config) {
        this._get('/account/forgot-password-verify', data, config);
    },

    SubmitForgotPasswordVerify: function (data, config) {
        this._send('/account/forgot-password-verify', data, config);
    },

    ValidateAccountInformation: function(data, config) {
        this._send('/account/validate-info', data, config);
    },
    ValidatePaymentInformation: function (data, config) {
        this._send('/account/validate-payment-info', data, config);
    },

    _send: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, error) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), xhr);
                    }
                    else if (config.callback) {
                        config.callback.call((config.scope || config.callback), true);
                    }
                }
            }
        );
    },

    _sendMixedData: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        $.ajax
        (
            url,
            {
                type: 'POST',
                data: data,
                context: this,
                contentType: false,
                processData: false,
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, error) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), xhr);
                    }
                    else if (config.callback) {
                        config.callback.call((config.scope || config.callback), true);
                    }
                }
            }
        );
    },

    _get: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: 'html',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function () {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback));
                    }
                }
            }
        );
    }
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Service/AccountService.js